import { ErrorPage } from "../../../components/ErrorPage";

export function NoTicketsFoundView({
  entityName = "tickets",
}: {
  entityName?: string;
}) {
  return (
    <ErrorPage
      title={`No ${entityName} matched your search. Please refine your filters.`}
      variant="not-found"
    />
  );
}
